var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlotIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_6394",
    "data-name": "Groupe 6394",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.482,
    height: 36.482,
    viewBox: "0 0 36.482 36.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_324",
    "data-name": "Rectangle 324",
    width: 36.481,
    height: 36.482,
    fill: "#4188f2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_626",
    "data-name": "Groupe 626",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_865",
    "data-name": "Trac\\xE9 865",
    d: "M18.241,0a18.241,18.241,0,0,0-12.9,31.139A18.241,18.241,0,1,0,18.241,0m1.4,33.609v-4.04a1.4,1.4,0,1,0-2.808,0V33.61A15.435,15.435,0,0,1,2.871,19.645H6.912a1.4,1.4,0,0,0,0-2.808H2.871A15.435,15.435,0,0,1,16.837,2.871V6.816a1.4,1.4,0,1,0,2.808,0V2.872A15.458,15.458,0,0,1,33.609,16.837h-4.04a1.4,1.4,0,0,0,0,2.808h4.04A15.458,15.458,0,0,1,19.645,33.609",
    transform: "translate(0 0)",
    fill: "#4188f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_866",
    "data-name": "Trac\\xE9 866",
    d: "M87.246,78.886l-5.6,3.578-7.024-6.748a1.4,1.4,0,0,0-1.945,2.025L80.5,85.254a1.4,1.4,0,0,0,1.729.171l6.529-4.173a1.4,1.4,0,0,0-1.512-2.366",
    transform: "translate(-63.232 -65.925)",
    fill: "#4188f2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlotIcon);
export default __webpack_public_path__ + "static/media/slot-icon.d5d7fdf07918f814a54ab0603c0266f1.svg";
export { ForwardRef as ReactComponent };